<template>
    <button @click="$emit('yes')">Sí</button>
    <button @click="$emit('no')">No</button>
</template>

<script>
export default{
    emits: ['yes', 'no']
}
</script>

<style scoped>

</style>